module.exports = __webpack_public_path__ + "static/img/contributor-persona.a9ff0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contributor-persona.png
// module id = 553
// module chunks = 1